"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8140],{

/***/ 28140:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ layout_LandingLayout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/logic/hooks/use-popup/index.ts
var use_popup = __webpack_require__(19895);
// EXTERNAL MODULE: ./src/ui/components/smart/landing/contact/ContactUsPopup.tsx
var ContactUsPopup = __webpack_require__(76655);
// EXTERNAL MODULE: ./src/logic/config/index.ts + 38 modules
var config = __webpack_require__(13223);
// EXTERNAL MODULE: ./src/logic/zustand/index.ts + 16 modules
var zustand = __webpack_require__(14398);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(79072);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(29630);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Box/Box.js + 1 modules
var Box = __webpack_require__(93789);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/logic/constants/links.ts
var links = __webpack_require__(84667);
// EXTERNAL MODULE: ./src/site-map.ts
var site_map = __webpack_require__(29951);
;// CONCATENATED MODULE: ./src/ui/components/smart/landing/layout/footer/LandingFooter.tsx








var LandingFooter = function(param) {
    var contactUsPopup = param.contactUsPopup;
    var isAuthenticated = (0,zustand/* useUserData */.v$)(function(state) {
        return state.authenticationStatus === config/* AuthenticateStatus.AUTHENTICATED */.xE.AUTHENTICATED;
    });
    var pathname = (0,next_router.useRouter)().pathname;
    var onContactClick = function() {
        if (pathname === site_map.sm.contactUs.url) {
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            });
        } else {
            contactUsPopup.handleOpen();
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        style: {
            backgroundColor: "#000",
            paddingBlock: "1rem",
            color: "#fff"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "page__content",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                    container: true,
                    spacing: 2,
                    pt: 8,
                    pb: 10,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                            item: true,
                            xs: 12,
                            sm: 12,
                            md: 6,
                            lg: 7,
                            xl: 7,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/assets/images/logo-white.png",
                                    alt: "eProcurement",
                                    style: {
                                        display: "block",
                                        maxWidth: "154px"
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    mt: 2,
                                    mb: 1,
                                    fontSize: {
                                        xs: 11,
                                        lg: 14
                                    },
                                    fontWeight: 400,
                                    maxWidth: "40ch",
                                    children: "eProcurement is a cloud based, AI powered, end-to-end data & procurement SaaS solution"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: 12,
                            sm: 12,
                            md: 3,
                            lg: 2.5,
                            xl: 2.5,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "start",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        fontSize: {
                                            xs: 11,
                                            lg: 14
                                        },
                                        fontWeight: 400,
                                        mb: 1,
                                        onClick: onContactClick,
                                        sx: {
                                            cursor: "pointer"
                                        },
                                        children: "Get in touch"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: site_map.sm.careers.index.url,
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            style: {
                                                all: "unset",
                                                cursor: "pointer"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                fontSize: {
                                                    xs: 11,
                                                    lg: 14
                                                },
                                                fontWeight: 400,
                                                mb: 1,
                                                children: "Careers"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: site_map.sm.blog.index.url,
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            style: {
                                                all: "unset",
                                                cursor: "pointer"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                fontSize: {
                                                    xs: 11,
                                                    lg: 14
                                                },
                                                fontWeight: 400,
                                                mb: 1,
                                                children: "Blog"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: site_map.sm.catalogue.index.url,
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            style: {
                                                all: "unset",
                                                cursor: "pointer"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                fontSize: {
                                                    xs: 11,
                                                    lg: 14
                                                },
                                                fontWeight: 400,
                                                mb: 1,
                                                children: isAuthenticated ? "Directory" : "Explore the Solution"
                                            })
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                            item: true,
                            xs: 12,
                            sm: 12,
                            md: 3,
                            lg: 2.5,
                            xl: 2.5,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    mb: 1,
                                    fontWeight: 600,
                                    fontSize: {
                                        xs: 13,
                                        lg: 16
                                    },
                                    children: "Contacts"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    fontSize: {
                                        xs: 11,
                                        lg: 14
                                    },
                                    fontWeight: 400,
                                    mb: 1,
                                    lineHeight: 1.5,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        href: links/* LOCATION_URL */.vc,
                                        target: "_blank",
                                        rel: "noreferrer noopener",
                                        style: {
                                            all: "unset",
                                            cursor: "pointer"
                                        },
                                        children: [
                                            "Dubai International Financial Center",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            "Dubai, UAE"
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    fontSize: {
                                        xs: 11,
                                        lg: 14
                                    },
                                    fontWeight: 400,
                                    mb: 1,
                                    lineHeight: 1.5,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "mailto:".concat(links/* EMAIL */.xK),
                                        target: "_blank",
                                        rel: "noreferrer noopener",
                                        style: {
                                            all: "unset",
                                            cursor: "pointer"
                                        },
                                        children: links/* EMAIL */.xK
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    display: "flex",
                    flexWrap: "wrap",
                    gap: 2,
                    justifyContent: "space-between",
                    alignItems: "center",
                    sx: {
                        opacity: 0.5
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                            display: "flex",
                            flexWrap: "wrap",
                            gap: 2,
                            justifyContent: "space-between",
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: site_map.sm.support.privacy_policy.url,
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        style: {
                                            textDecoration: "none",
                                            color: "inherit"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            fontSize: {
                                                xs: 11,
                                                lg: 14
                                            },
                                            fontWeight: 400,
                                            mb: 1,
                                            sx: {
                                                cursor: "pointer"
                                            },
                                            className: "underline-on-hover",
                                            children: "Privacy Policy"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: site_map.sm.support.terms_and_conditions.url,
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        style: {
                                            textDecoration: "none",
                                            color: "inherit"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            fontSize: {
                                                xs: 11,
                                                lg: 14
                                            },
                                            fontWeight: 400,
                                            mb: 1,
                                            sx: {
                                                cursor: "pointer"
                                            },
                                            className: "underline-on-hover",
                                            children: "Terms & Conditions"
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            fontSize: {
                                xs: 11,
                                lg: 14
                            },
                            fontWeight: 400,
                            mb: 1,
                            children: "eProcurment \xa9 2025. All Rights Reserved"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var footer_LandingFooter = (LandingFooter);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Close.js
var Close = __webpack_require__(50594);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Menu.js
var Menu = __webpack_require__(326);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Person.js
var Person = __webpack_require__(15398);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Skeleton/Skeleton.js + 1 modules
var Skeleton = __webpack_require__(57412);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Button/Button.js + 1 modules
var Button = __webpack_require__(54225);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(80562);
// EXTERNAL MODULE: ./src/ui/components/smart/landing/components/buttons/PrimaryButton.tsx
var PrimaryButton = __webpack_require__(82120);
;// CONCATENATED MODULE: ./src/ui/components/smart/landing/layout/navbar/LandingNavbar.tsx















var drawerLinkItemProps = {
    fontSize: 16,
    fontWeight: 600,
    sx: {
        cursor: "pointer",
        borderRadius: "8px",
        px: 1,
        transition: "all 200ms"
    },
    color: "#000"
};
var selectedDrawerLinkItemProps = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, drawerLinkItemProps), {
    sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, drawerLinkItemProps.sx), {
        backgroundColor: "#014AA4"
    }),
    color: "#fff"
});
var LandingNavbar = function(param) {
    var contactUsPopup = param.contactUsPopup;
    var router = (0,next_router.useRouter)();
    var isAuthenticated = (0,zustand/* useUserData */.v$)(function(state) {
        return state.authenticationStatus === config/* AuthenticateStatus.AUTHENTICATED */.xE.AUTHENTICATED;
    });
    var isInitializing = (0,zustand/* useUserData */.v$)(function(state) {
        return state.isInitializing;
    });
    var menu = (0,use_popup/* default */.Z)();
    var onContactClick = function() {
        if (router.pathname === site_map.sm.contactUs.url) {
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            });
        } else {
            contactUsPopup.handleOpen();
        }
    };
    var links = [
        {
            label: isAuthenticated ? "Directory" : "Explore the Solution",
            href: site_map.sm.catalogue.index.url
        },
        {
            label: "Careers",
            href: site_map.sm.careers.index.url,
            isSelected: !contactUsPopup.isOpen && router.pathname === site_map.sm.careers.index.url
        },
        {
            label: "Blog",
            href: site_map.sm.blog.index.url,
            isSelected: !contactUsPopup.isOpen && router.pathname === site_map.sm.blog.index.url
        },
        {
            label: "Contact us",
            href: undefined,
            isSelected: contactUsPopup.isOpen || router.pathname === site_map.sm.contactUs.url,
            onClick: onContactClick
        }, 
    ];
    var authLinks = isInitializing ? [] : isAuthenticated ? [
        {
            label: "Go To Portal",
            href: site_map.sm.portals.index.url,
            isSelected: false,
            onClick: undefined
        }, 
    ] : [
        {
            label: "Login",
            href: site_map.sm.login.url,
            isSelected: false,
            onClick: undefined
        },
        {
            label: "Get Started",
            href: site_map.sm.register.index.url,
            isSelected: false,
            onClick: undefined
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("nav", {
                style: {
                    display: "none"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: site_map.sm.home.url,
                        children: "Home"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: site_map.sm.login.url,
                        children: "Login"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: site_map.sm.contactUs.url,
                        children: "Contact Us"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: site_map.sm.register.index.url,
                        children: "Register"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: site_map.sm.catalogue.index.url,
                        children: "Directory"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: site_map.sm.becomeASeller.url,
                        children: "Become Seller"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: site_map.sm.register.asBuyer.index.url,
                        children: "Become Buyer"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                sx: {
                    position: "fixed",
                    top: 0,
                    left: 0,
                    right: 0,
                    zIndex: 999,
                    backgroundColor: "white",
                    backdropFilter: "blur(44px)",
                    boxShadow: "0px 0px 28px 7px #4242421a",
                    paddingBlock: {
                        xs: "0.85rem",
                        sm: "0.85rem",
                        md: "0.85rem",
                        lg: "1.15rem",
                        xl: "1.15rem"
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        component: "nav",
                        sx: {
                            maxWidth: "calc(1200px + 3rem)",
                            paddingInline: "1.5rem",
                            marginInline: "auto",
                            alignItems: "center",
                            justifyContent: "space-between",
                            display: {
                                xs: "none",
                                sm: "none",
                                md: "none",
                                lg: "flex",
                                xl: "flex"
                            }
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: site_map.sm.home.url,
                                passHref: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    style: {
                                        objectFit: "contain",
                                        height: "40px",
                                        cursor: "pointer"
                                    },
                                    src: "/assets/images/logo.png",
                                    alt: "Logo"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                display: "flex",
                                gap: 3,
                                children: links.map(function(link) {
                                    return link.href ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: link.href,
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            style: {
                                                textDecoration: "none",
                                                color: "inherit"
                                            },
                                            onClick: link.onClick,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, link.isSelected ? selectedDrawerLinkItemProps : drawerLinkItemProps), {
                                                children: link.label
                                            }))
                                        })
                                    }, link.label) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, link.isSelected ? selectedDrawerLinkItemProps : drawerLinkItemProps), {
                                        onClick: link.onClick,
                                        children: link.label
                                    }), link.label);
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: isInitializing ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                    variant: "rectangular",
                                    width: "200px",
                                    height: "30px",
                                    sx: {
                                        borderRadius: "8px"
                                    }
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: isAuthenticated ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: site_map.sm.portals.index.url,
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PrimaryButton/* default */.Z, {
                                            children: "Go To Portal"
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        style: {
                                            display: "flex",
                                            gap: "1rem",
                                            alignItems: "center"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: site_map.sm.login.url,
                                                passHref: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                    type: "button",
                                                    variant: "text",
                                                    sx: {
                                                        color: "#000",
                                                        fontWeight: 600
                                                    },
                                                    startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Person/* default */.Z, {}),
                                                    children: "Log in"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: site_map.sm.register.index.url,
                                                passHref: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PrimaryButton/* default */.Z, {
                                                    children: "Get Started"
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        component: "nav",
                        sx: {
                            maxWidth: "calc(1200px + 3rem)",
                            paddingInline: "1.5rem",
                            marginInline: "auto",
                            alignItems: "center",
                            justifyContent: "space-between",
                            display: {
                                xs: "flex",
                                sm: "flex",
                                md: "flex",
                                lg: "none",
                                xl: "none"
                            }
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: site_map.sm.home.url,
                                passHref: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    style: {
                                        objectFit: "contain",
                                        height: "35px",
                                        cursor: "pointer"
                                    },
                                    src: "/assets/images/icon.png",
                                    alt: "Icon"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                type: "button",
                                sx: {
                                    color: "#000"
                                },
                                onClick: menu.handleOpen,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* default */.Z, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                sx: {
                                    position: "fixed",
                                    width: "100%",
                                    backgroundColor: "white",
                                    top: 0,
                                    left: 0,
                                    transition: "all 0.7s cubic-bezier(0.25, 1, 0.5, 1)",
                                    flexDirection: "column",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    gap: "1rem",
                                    pointerEvents: menu.isOpen ? "auto" : "none",
                                    clipPath: menu.isOpen ? "circle(150% at 100% 0)" : "circle(0 at 100% 0)",
                                    display: {
                                        xs: "flex",
                                        sm: "flex",
                                        md: "flex",
                                        lg: "none",
                                        xl: "none"
                                    }
                                },
                                py: 1.75,
                                px: 3,
                                className: "min-height-dvh",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                        display: "flex",
                                        justifyContent: "space-between",
                                        width: "100%",
                                        alignItems: "center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                style: {
                                                    objectFit: "contain",
                                                    height: "35px",
                                                    cursor: "pointer"
                                                },
                                                src: "/assets/images/icon.png",
                                                alt: "Icon"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                                type: "button",
                                                sx: {
                                                    color: "#000"
                                                },
                                                onClick: menu.handleClose,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {})
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        gap: 2,
                                        children: (0,_to_consumable_array/* default */.Z)(links).concat((0,_to_consumable_array/* default */.Z)(authLinks)).map(function(link) {
                                            return link.href ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: link.href,
                                                passHref: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    style: {
                                                        textDecoration: "none",
                                                        color: "inherit"
                                                    },
                                                    onClick: function() {
                                                        var // @ts-ignore
                                                        ref;
                                                        menu.handleClose();
                                                        (ref = link.onClick) === null || ref === void 0 ? void 0 : ref.call(link);
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, link.isSelected ? selectedDrawerLinkItemProps : drawerLinkItemProps), {
                                                        children: link.label
                                                    }))
                                                })
                                            }, link.label) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, link.isSelected ? selectedDrawerLinkItemProps : drawerLinkItemProps), {
                                                onClick: function() {
                                                    var ref;
                                                    menu.handleClose();
                                                    (ref = link.onClick) === null || ref === void 0 ? void 0 : ref.call(link);
                                                },
                                                children: link.label
                                            }), link.label);
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        fontSize: {
                                            xs: 11,
                                            lg: 14
                                        },
                                        fontWeight: 400,
                                        color: "#000",
                                        textAlign: "center",
                                        sx: {
                                            opacity: 0.75
                                        },
                                        children: "eProcurment \xa9 2025. All Rights Reserved"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var navbar_LandingNavbar = (LandingNavbar);

;// CONCATENATED MODULE: ./src/ui/components/smart/landing/layout/LandingLayout.tsx






var LandingLayout = function(param) {
    var children = param.children;
    var contactUsPopup = (0,use_popup/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    minHeight: "100vh"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(navbar_LandingNavbar, {
                        contactUsPopup: contactUsPopup
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            flexGrow: 1,
                            width: "100%"
                        },
                        children: children
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_LandingFooter, {
                        contactUsPopup: contactUsPopup
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactUsPopup/* default */.Z, {
                popup: contactUsPopup
            })
        ]
    });
};
/* harmony default export */ var layout_LandingLayout = (LandingLayout);


/***/ })

}]);